import { render } from "./AccountManageCreateForm.vue?vue&type=template&id=fa30a690&lang=true"
import script from "./AccountManageCreateForm.vue?vue&type=script&lang=js"
export * from "./AccountManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__